import React from 'react';
import { format } from 'date-fns';
import { sr } from 'date-fns/locale';

const StatusBadge = ({ status, isArchived }) => {
  if (isArchived) return <span className="px-2 py-1 text-xs font-medium bg-red-100 text-red-700 rounded-full">Arhiviran</span>;
  const map = {
    initiated: { label: 'Iniciran', cls: 'bg-yellow-100 text-yellow-700' },
    in_progress: { label: 'Aktivan', cls: 'bg-blue-100 text-blue-700' },
    agreed: { label: 'Dogovoren', cls: 'bg-green-100 text-green-700' },
    completed: { label: 'Zaključen', cls: 'bg-gray-100 text-gray-700' },
    cancelled: { label: 'Otkazan', cls: 'bg-red-100 text-red-700' },
  };
  const s = map?.[status] || { label: status, cls: 'bg-gray-100 text-gray-700' };
  return <span className={`px-2 py-1 text-xs font-medium rounded-full ${s?.cls}`}>{s?.label}</span>;
};

const NegotiationTable = ({ negotiations, selectedId, onSelect, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!negotiations?.length) {
    return (
      <div className="text-center py-16 text-gray-500">
        <p className="text-lg font-medium">Nema pregovora</p>
        <p className="text-sm mt-1">Pokušajte sa drugačijim filterima</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-200 bg-gray-50">
            <th className="text-left py-3 px-4 font-semibold text-gray-600">Učesnici</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-600">Predmet</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-600">Datum</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-600">Status</th>
          </tr>
        </thead>
        <tbody>
          {negotiations?.map((neg) => (
            <tr
              key={neg?.id}
              onClick={() => onSelect(neg)}
              className={`border-b border-gray-100 cursor-pointer transition-colors ${
                selectedId === neg?.id ? 'bg-blue-50' : 'hover:bg-gray-50'
              }`}
            >
              <td className="py-3 px-4">
                <p className="font-medium text-gray-900">{neg?.buyerName || 'N/A'}</p>
                <p className="text-xs text-gray-500">↔ {neg?.sellerName || 'N/A'}</p>
              </td>
              <td className="py-3 px-4">
                <p className="text-gray-800 truncate max-w-xs">{neg?.offerName || 'Bez predmeta'}</p>
                <p className="text-xs text-gray-500 truncate max-w-xs">{neg?.initialMessage?.substring(0, 50)}{neg?.initialMessage?.length > 50 ? '...' : ''}</p>
              </td>
              <td className="py-3 px-4 text-gray-600 whitespace-nowrap">
                {neg?.createdAt ? format(new Date(neg?.createdAt), 'dd.MM.yyyy', { locale: sr }) : '-'}
              </td>
              <td className="py-3 px-4">
                <StatusBadge status={neg?.status} isArchived={neg?.isArchived} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default NegotiationTable;
